/* import __COLOCATED_TEMPLATE__ from './receive-verify-work-sample-overlay.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { enqueueTask } from 'ember-concurrency';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-referral-receive-verify-work-sample-overlay';
const BACKDROP_CLASS_NAME = `${CLASS_NAME}__backdrop`;

class ReceiveVerifyWorkSampleOverlay extends Component {
  @tracked responseText = '';

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.args.onlySmallAndDownFlatEdges && 'only-small-and-down-flat-edges',
    );
  }

  get backdropClassNames() {
    return clsx(
      BACKDROP_CLASS_NAME,
      this.args.onlySmallAndDownFlatEdges && 'only-small-and-down-flat-edges',
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get possessiveName() {
    const { fullName } = this.args.projectDigest.user;
    return fullName.slice(-1) === 's' ? `${fullName}'` : `${fullName}'s`;
  }

  @enqueueTask
  *handleSubmitTask(projectdigestVerification, notes = '') {
    try {
      // only resave if a response was added.
      if (notes) {
        yield this.args.onSubmit(projectdigestVerification, notes);
      }

      this.args.onCloseOverlay();

      // next in queue
      this.args.afterSubmit();
    } catch (e) {
      handleErrorResponseWithModal(this, e, 'Could not send your response at this time. Please try again in a moment.');
    }
  }

  @action
  onInputResponse(value) {
    this.responseText = value;
  }

  @action
  handleDismiss() {
    this.args.onCloseOverlay();
  }
}

export default ReceiveVerifyWorkSampleOverlay;
